import { createRoutine } from 'redux-saga-routines'

export const SET = 'PORTFOLIO/SET'
export const CONTENT = createRoutine('PORTFOLIO/CONTENT')
